module.exports = __webpack_public_path__ + "BMFTR_Logo.svg.1a46968a4df490ba0eadd9518133e225.png";